export const listProgramMembershipsByUserId = /* GraphQL */ `
  query ListProgramMembershipsByUserId($programMemberId: ID) {
    listProgramMemberships(
      filter: { programMemberId: { eq: $programMemberId } }
    ) {
      items {
        id
        programRole
        programMember {
          id
          firstName
          lastName
          email
          lastName
          npi
          pgy
        }
        program {
          id
          name
          description
        }
      }
    }
  }
`;

export const getUserInvitationUnauthed = /* GraphQL */ `
  query GetUserInvitationUnauthed($id: ID!) {
    getUserInvitation(id: $id) {
      id
      email
      institutionId
      invitationStatus
      inviteeId
      programId
      role
    }
  }
`;

export const getUserInvitationsByEmailUnauthed = /* GraphQL */ `
  query GetUserInvitationsByEmailUnauthed($emailLower: AWSEmail!) {
    userInvitationsByEmailLower(emailLower: $emailLower) {
      items {
        id
        email
      }
    }
  }
`;

export const assessmentHistoryForCCC = /* GraphQL */ `
  query assessmentHistoryForCCC($input: PaginatableAssessmentHistoryArgs) {
    paginatableAssessmentHistory(input: $input) {
      nextToken
      total
      items {
        id
        subjectId
        subject {
          id
          userId
          user {
            id
            email
            emailLower
            institutionId
            cognitoUsername
            firstName
            lastName
            suffix
            npi
            pgy
            lastLogin
            eulaAcceptedDate
            simpl1Id
            deviceToken
            devicePlatform
            inviteId
            createdAt
            updatedAt
            __typename
          }
          currentPGY
          currentRole
          currentTraineeType
          createdAt
          updatedAt
          __typename
        }
        subjectUserId
        raterId
        rater {
          id
          userId
          user {
            id
            email
            emailLower
            institutionId
            cognitoUsername
            firstName
            lastName
            suffix
            npi
            pgy
            lastLogin
            eulaAcceptedDate
            simpl1Id
            deviceToken
            devicePlatform
            inviteId
            createdAt
            updatedAt
            __typename
          }
          currentPGY
          currentRole
          currentTraineeType
          createdAt
          updatedAt
          __typename
        }
        raterUserId
        activityId

        activity {
          id
          title
          description
          subActivities {
            nextToken
            __typename
          }
          assessmentId
          assessment {
            id
            title
            description
            instrumentId
            expirationDurationHours
            sponsorId
            requireTraineeSelfAssessment
            authorId
            published
            archived
            version
            creationDurationHours
            createdAt
            updatedAt
            __typename
          }
          sponsorId
          sponsor {
            id
            name
            description
            createdAt
            updatedAt
            __typename
          }
          version
          acgmeProcedures {
            nextToken
            __typename
          }
          simpl1Id
          createdAt
          updatedAt
          activitySubActivitiesId
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          creator {
            id
            email
            emailLower
            institutionId
            cognitoUsername
            firstName
            lastName
            suffix
            npi
            pgy
            lastLogin
            eulaAcceptedDate
            simpl1Id
            deviceToken
            devicePlatform
            inviteId
            createdAt
            updatedAt
            __typename
          }
          programId
          program {
            id
            name
            description
            institutionId
            simpl1Id
            createdAt
            updatedAt
            __typename
          }
          activityEventDate
          notes
          createdAt
          updatedAt
          __typename
        }
        programId
        program {
          id
          name
          description
          institutionId
          institution {
            id
            name
            description
            createdAt
            updatedAt
            __typename
          }
          simpl1Id
          createdAt
          updatedAt
          __typename
        }
        assessmentId
        assessment {
          id
          title
          description
          instrumentId
          instrument {
            id
            title
            description
            authorId
            version
            createdAt
            updatedAt
            __typename
          }
          multiActivities {
            nextToken
            __typename
          }
          expirationDurationHours
          sponsorId
          sponsor {
            id
            name
            description
            createdAt
            updatedAt
            __typename
          }
          requireTraineeSelfAssessment
          published
          archived
          version
          creationDurationHours
          createdAt
          updatedAt
          __typename
        }
        answers {
          items {
            id
            questionId
            question {
              id
              defaultPrompt
              required
              selfAssessmentPrompt
              sortingIndex
              answerOptions {
                items {
                  anchor
                  value
                }
              }
              title
              helpText
              inputType
              instrumentId
              createdAt
              updatedAt
              __typename
            }
            valueType
            value
            assessmentEventId
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        expirationDate
        completionDate
        declined
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;

export const activitiesByUsersForCreate = /* GraphQL */ `
  query ActivitiesByUsersForCreate($input: PaginatableActivitiesByUsersArgs) {
    paginatableActivitiesByUsers(input: $input) {
      nextPage
      total
      error
      activities {
        id
        title
        description
        categories
        assessmentId
        sponsor {
          id
          activityLabel
          branding {
            colors {
              primary
              secondary
              light
            }
            logos {
              fullMono
              fullColor
              squareMono
              squareColor
              email
            }
            __typename
          }
          description
          name
          __typename
        }
        programIds
        __typename
      }
      __typename
    }
  }
`;

export const pendingAssessmentsForHomeScreen = /* GraphQL */ `
  query PendingAssessmentsForHomeScreen($userId: String) {
    usersPendingAssessments(userId: $userId) {
      id
      subjectId
      subject {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          createdAt
          updatedAt
          __typename
        }
        currentPGY
        currentRole
        currentTraineeType
        createdAt
        updatedAt
        __typename
      }
      subjectUserId
      raterId
      raterUserId
      activityId
      activity {
        id
        title
        description
        assessmentId
        sponsorId
        sponsor {
          id
          name
          description
          networks {
            nextToken
            __typename
          }
          branding {
            colors {
              primary
              secondary
              light
            }
            logos {
              fullMono
              fullColor
              squareMono
              squareColor
              email
            }
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        authorId
        version
        simpl1Id
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        programId
        activityEventDate
        notes
        createdAt
        updatedAt
        __typename
      }
      programId
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        expirationDurationHours
        sponsorId
        sponsor {
          id
          name
          description
          branding {
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        requireTraineeSelfAssessment
        authorId
        published
        archived
        version
        creationDurationHours
        createdAt
        updatedAt
        __typename
      }
      expirationDate
      completionDate
      declined
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const getAssessmentEventForCompletion = /* GraphQL */ `
  query GetAssessmentEventForCompletion($id: ID!) {
    getAssessmentEvent(id: $id) {
      id
      subjectId
      subject {
        id
        userId
        user {
          id
          email
          emailLower
          institutionId
          cognitoUsername
          firstName
          lastName
          suffix
          npi
          pgy
          lastLogin
          eulaAcceptedDate
          simpl1Id
          deviceToken
          devicePlatform
          inviteId
          createdAt
          updatedAt
          __typename
        }
        activityEventId
        activityEvent {
          id
          creatorId
          programId
          activityEventDate
          notes
          createdAt
          updatedAt
          __typename
        }
        currentPGY
        currentRole
        currentTraineeType
        createdAt
        updatedAt
        __typename
      }
      subjectUserId
      raterId
      raterUserId
      activityId
      activity {
        id
        title
        description
        assessmentId
        sponsorId
        sponsor {
          id
          name
          description
          branding {
            colors {
              primary
              secondary
              light
            }
            logos {
              fullMono
              fullColor
              squareMono
              squareColor
              email
            }
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        authorId
        version
        acgmeProcedures {
          items {
            id
            activityID
            acgmeProcedureID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        simpl1Id
        createdAt
        updatedAt
        activitySubActivitiesId
        __typename
      }
      activityEventId
      activityEvent {
        id
        creatorId
        programId
        activityEventDate
        notes
        createdAt
        updatedAt
        __typename
      }
      programId
      assessmentId
      assessment {
        id
        title
        description
        instrumentId
        expirationDurationHours
        sponsorId
        requireTraineeSelfAssessment
        authorId
        published
        archived
        version
        creationDurationHours
        showFeedbackQuestionsToTrainees
        sendEmailForSelfAssessment
        createdAt
        updatedAt
        __typename
      }
      expirationDate
      completionDate
      declined
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const siblingUsersForCreate = /* GraphQL */ `
  query siblingUsersForCreate($input: PaginatableSiblingUsersArgs) {
    paginatableSiblingUsers(input: $input) {
      nextToken
      total
      items {
        id
        email
        emailLower
        institutionId
        cognitoUsername
        firstName
        lastName
        suffix
        npi
        pgy
        lastLogin
        eulaAcceptedDate
        programMemberships {
          items {
            id
            programRole
            traineeType
            programMemberId
            programId
            program {
              id
              name
              description
              institutionId
              simpl1Id
              createdAt
              updatedAt
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        simpl1Id
        deviceToken
        devicePlatform
        inviteId
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;

export const getProgramForSiblingUsers = /* GraphQL */ `
  query getProgramForSiblingUsers($id: ID!) {
    getProgram(id: $id) {
      id
      name
      networks {
        items {
          network {
            traineeCanRateTrainee
          }
        }
      }
    }
  }
`;

export const getUserForSubmitAssessmentRequest = /* GraphQL */ `
  query getUserForSubmitAssessmentRequest($id: ID!) {
    getUser(id: $id) {
      id
      email
      firstName
      lastName
      pgy
      jobTitle
      programMemberships {
        items {
          id
          programRole
          traineeType
          programId
          startDate
          endDate
        }
      }
    }
  }
`;

export const getActivityForSubmitAssessmentRequest = /* GraphQL */ `
  query getActivityForSubmitAssessmentRequest($id: ID!) {
    getActivity(id: $id) {
      id
      title
      description
      assessmentId
      deletedAt
    }
  }
`;

export const createActivityEventForSubmitAssessmentRequest = /* GraphQL */ `
  mutation createActivityEventForSubmitAssessmentRequest(
    $input: CreateActivityEventInput!
  ) {
    createActivityEvent(input: $input) {
      id
      creatorId
      programId
      activityEventDate
      notes
      createdAt
      updatedAt
    }
  }
`;

export const getAssessmentForSubmitAssessmentRequest = /* GraphQL */ `
  query getAssessmentForSubmitAssessmentRequest($id: ID!) {
    getAssessment(id: $id) {
      id
      title
      description
      instrumentId
      expirationDurationHours
      sponsorId
      requireTraineeSelfAssessment
      authorId
      published
      archived
      version
      creationDurationHours
      showFeedbackQuestionsToTrainees
      sendEmailForSelfAssessment
      createdAt
      updatedAt
      __typename
    }
  }
`;
